import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {NoteDataModel} from '../../../models/notes/note-data.model';
import {NotesService} from '../../../services/notes.service';
import {Globals} from '../../../globals';
import {TdoNoteQueryModel} from '../../../main-interface/controls/tdo-notes/models/tdo-note-query.model';
import {TdoNoteAssociatedObject, TdoNoteSaveModel} from '../../../main-interface/controls/tdo-notes/models/tdo-note-save-model';
import { MessagingConstants } from 'src/app/models/MessagingConstants';
import { MessagingService } from 'src/app/services/messaging.service';
import {NoteCategoryEnum} from "../../../models/enum/note-category.enum";
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TdoNoteBuilderComponent } from 'src/app/main-interface/controls/tdo-note-builder/tdo-note-builder.component';
import { TdoMacroNotesComponent } from 'src/app/main-interface/controls/tdo-macro-notes/tdo-macro-notes.component';

@Component({
  selector: 'app-tdo-simple-note',
  templateUrl: './tdo-simple-note.component.html',
  styleUrls: ['./tdo-simple-note.component.scss']
})
export class TdoSimpleNoteComponent implements OnInit, OnChanges {
  @Input() width: string = '100%';
  @Input() height: string = '300px';
  @Input() objectId: string;
  @Input() parentObjectName: string;
  @Input() CaseProcedureId: string;
  @Input() PatientCaseId: string;
  @Input() PatientId: string;
  @Input() disabled: boolean = false;
  @Input() categoryEnumId: string;
  @Input() typeEnumId: string;
  @Input() numRows: number = 15;
  @Input() isHideBorder: boolean = false;
  @Input() isActionButtonsOnRight: boolean = false;

  @Output() noteReady = new EventEmitter();

  note: NoteDataModel = new NoteDataModel();

  constructor(private dialog: MatDialog,
      private messagingService: MessagingService,
      private noteService: NotesService,
      private globals: Globals) {
    this.note.Note = '';
  }

  ngOnInit(): void {
    if (!this.disabled) {
      const qo = new TdoNoteQueryModel();
      qo.objectId = this.objectId;
      qo.parentObjectName = this.parentObjectName;
      qo.patientId = this.PatientId;
      qo.categoryEnumId = this.categoryEnumId;
      qo.typeEnumId = this.typeEnumId;
      this.noteService.getNotes(qo).subscribe((res) => {
        if (res.length > 0) {
          this.note = res[0];
          this.noteReady.emit();
        }
      });
    }
  }

  onNoteInput(event: any) {
    if (this.objectId) {
      this.saveNote(event);
    }
  }

  private saveNote(event: any) {
    const so = new TdoNoteSaveModel();
    so.dataNote = this.note;
    so.patientId = this.PatientId;
    if (this.categoryEnumId) {
      so.categoryEnumIds = [this.categoryEnumId];
    }
    if (this.typeEnumId) {
      so.typeEnumIds = [this.typeEnumId];
    }
    const assoc = new TdoNoteAssociatedObject();
    if (this.PatientCaseId) {
      assoc.parentObjectName = 'dataPatientCase';
      assoc.objectId = this.PatientCaseId;
    } else {
      if(this.objectId != "NEWAPPT" ) {
        // do not add new appoitment  appotment
        assoc.parentObjectName = this.parentObjectName;
        assoc.objectId = this.objectId;
      }
    }
    so.associatedObjects.push(assoc);

    so.text = event;
    this.noteService.saveNote(so).subscribe((res) => {
      this.note = res;
      if (this.categoryEnumId !== NoteCategoryEnum.InsuranceCardInfo) {
        this.messagingService.sendComponentMessage(MessagingConstants.NOTES_REFRESH, {});
      }
    });
  }

  saveAppointmentNote(PatientCaseId: string, CaseProcedureId: string, appointmentId: string) {
    const so = new TdoNoteSaveModel();
    so.dataNote = this.note;
    so.patientId = this.PatientId;
    const dataAppointmentAssoc = new TdoNoteAssociatedObject();
    dataAppointmentAssoc.parentObjectName = 'dataAppointment';
    dataAppointmentAssoc.objectId = appointmentId;
    so.associatedObjects.push(dataAppointmentAssoc);
    if (this.PatientCaseId || PatientCaseId) {
      const assoc = new TdoNoteAssociatedObject();
      assoc.parentObjectName = 'dataPatientCase';
      assoc.objectId = PatientCaseId;
      so.associatedObjects.push(assoc);
    }

    so.text = this.note.Note;
    this.noteService.saveNote(so).subscribe((res) => {
      this.note = res;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.objectId) {
      const qo = new TdoNoteQueryModel();
      qo.objectId = this.objectId;
      qo.parentObjectName = this.parentObjectName;
      qo.patientId = this.PatientId;
      qo.categoryEnumId = this.categoryEnumId;
      qo.typeEnumId = this.typeEnumId;
      this.noteService.getNotes(qo).subscribe((res) => {
        if (res.length > 0) {
          this.note = res[0];
          this.noteReady.emit();
        } else {
          this.note = new NoteDataModel();
          this.note.Note = '';
        }
      });
    }
  }

  update() {
    const qo = new TdoNoteQueryModel();
    qo.objectId = this.objectId;
    qo.parentObjectName = this.parentObjectName;
    qo.patientId = this.globals.currentPatientId;
    qo.categoryEnumId = this.categoryEnumId;
    qo.typeEnumId = this.typeEnumId;
    this.noteService.getNotes(qo).subscribe((res) => {
      if (res.length > 0) {
        this.note = res[0];
        this.noteReady.emit();
      } else {
        this.note = new NoteDataModel();
        this.note.Note = '';
      }
    });
  }

  openNoteBuilder(dataNote: NoteDataModel) {
    const config = new MatDialogConfig();
    config.data = dataNote;
    config.panelClass = 'tdo-note-dialog-main';
    this.dialog.open(TdoNoteBuilderComponent, config).afterClosed().subscribe((data) => {
      if(data)  {
      if (data.length > 0) {
        dataNote.Note = data;
        this.saveNote(dataNote.Note);
      }
    }
    });
  }

  openMacroNotes(dataNote: NoteDataModel) {
    const config = new MatDialogConfig();
    config.data = dataNote;
    config.panelClass = 'tdo-note-dialog-main';
    this.dialog.open(TdoMacroNotesComponent, config).afterClosed().subscribe((data) => {
      if(data)  {
      if (data.length > 0) {
        dataNote.Note += '\n' + data;
        this.saveNote(dataNote.Note);
      }
    }
    });
  }
}
